import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module';

import { PdfViewerModule } from 'ng2-pdf-viewer';

import { HttpClientModule } from '@angular/common/http';
import { WebComponent } from './web/web.component';
import { WritingComponent } from './writing/writing.component';
import { ArtComponent } from './art/art.component';
import { MusicComponent } from './music/music.component';
import { HomeComponent } from './home/home.component';
import { MoonComponent } from './common/starry-night/moon/moon.component';
import { StarComponent } from './common/starry-night/star/star.component';
import { DocFromGmailComponent } from './web/doc-from-gmail/doc-from-gmail.component';
import { SheetFromGmailComponent } from './web/sheet-from-gmail/sheet-from-gmail.component';
import { IlluminatingCoComponent } from './web/illuminating-co/illuminating-co.component';
import { StarfieldComponent } from './common/starry-night/starfield/starfield.component';
import { StarryNightComponent } from './common/starry-night/starry-night.component';
import { TerrainComponent } from './common/starry-night/terrain/terrain.component';
import { ConstellationComponent } from './common/starry-night/constellation/constellation.component';
import { AtmosphereComponent } from './common/starry-night/atmosphere/atmosphere.component';

@NgModule({
  declarations: [
    AppComponent,
    WebComponent,
    WritingComponent,
    ArtComponent,
    MusicComponent,
    HomeComponent,
    MoonComponent,
    StarComponent,
    DocFromGmailComponent,
    SheetFromGmailComponent,
    IlluminatingCoComponent,
    StarfieldComponent,
    StarryNightComponent,
    TerrainComponent,
    ConstellationComponent,
    AtmosphereComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    PdfViewerModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
